<template>
    <div class="financeCalculator__form__row">
        <label :for="id" v-if="id && label">{{ label }}</label>
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String
        },
        label: {
            type: String
        }
    }
}
</script>